import React from 'react';
import { ClickableBox, SpacingBox, FlexBox } from './Boxes';
import { BoldOrParagraph } from './Typography';
import { changeAppLanguage, currentLanguage } from '../i18n';

const options = [
  { value: 'de', label: 'German' },
  { value: 'en', label: 'English' },
];

const Language = ({ value }) => (
  <SpacingBox marginRight="sm">
    <ClickableBox onClick={() => changeAppLanguage(value)}>
      <BoldOrParagraph bold={currentLanguage() === value}>
        {value}
      </BoldOrParagraph>
    </ClickableBox>
  </SpacingBox>
);

export const LanguagePicker = () => (
  <FlexBox>
    {options.map((o) => (
      <Language key={o.value} value={o.value} />
    ))}
  </FlexBox>
);

export default LanguagePicker;
